// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import DocumentList from './components/DocumentList';
import InvoiceViewer from './components/InvoiceViewer';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';
import './components/Auth.css';
import AnimatedHeaderLogo from './components/AnimatedHeaderLogo';


function Header() {
  const location = useLocation();
  const { currentUser } = useAuth();

  return (
    <header className="App-header">
      <div className="header-container">
        <Link to="/">
          <AnimatedHeaderLogo />
        </Link>

        <nav className="header-nav">
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Documents</Link>
          <Link to="/dashboard" className={location.pathname === '/dashboard' ? 'active' : ''}>Dashboard</Link>
          {currentUser ? (
            <>
              <Link to="/logout" className="logout-link">Logout</Link>
            </>
          ) : (
            <>
              <Link to="/login" className={location.pathname === '/login' ? 'active' : ''}>Login</Link>
              <Link to="/register" className={location.pathname === '/register' ? 'active' : ''}>Register</Link>
            </>
          )}
        </nav>

        {currentUser && (
          <div className="header-user-info">
            <span className="user-email">Logged in as: {currentUser.email}</span>
          </div>
        )}
      </div>
    </header>
  );
}

function Logout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <div className="auth-container">
      <h2>Logging out...</h2>
      {handleLogout()}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="App-main">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DocumentList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validate/:id"
                element={
                  <ProtectedRoute>
                    <InvoiceViewer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/logout"
                element={
                  <ProtectedRoute>
                    <Logout />
                  </ProtectedRoute>
                }
              />

              {/* Catch-all Route */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
